/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Istprivatversichert2Inputs */



/**

* @param {_Field_Istprivatversichert2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_istprivatversichert2 = /** @type {((inputs?: _Field_Istprivatversichert2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Istprivatversichert2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Privat versichert am 31.12.2002")
});
export { _field_istprivatversichert2 as "_field_istPrivatVersichert" }